import sms from './sms'
import email from './email'
import notification from './notification'

export default {
  name: 'Sent',
  path: 'sent',
  meta: {
    label: 'sent',
    auth: 'sent'
  },
  component: {
    name: 'Sent',
    render(c) {
      return c('router-view')
    }
  },
  children: [sms, email, notification]
}
